import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { cardsTexts } from './data';

import styles from './styles.module.scss';

export const CardsVideoCall = memo(() => {
  const { t } = useTranslation('welcome');

  const cards = useMemo(() => (
    cardsTexts.map(({ text, icon, id }) => (
      <div
        key={id}
        className={styles.card}
      >
        <img
          alt=""
          src={icon}
          loading="lazy"
        />
        <p>{t(text)}</p>
      </div>
    ))
  ), [t]);

  return (
    <div className={styles.cardsContainer}>
      {cards}
    </div>
  );
});
